/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgUnderlineKorean = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1599 739h321v123h-321v930h-139V0h139v739zM244 1256q149-61 275-158t230-218q110-129 175-278t85-319H320V160h837q-5 209-66 386T925 873t-252 272-322 223l-107-112zm12 792v-128h1408v128H256z"
    }));
export default SvgUnderlineKorean;
